module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: [_vm.cssClass, 'list-group-item', 'executor'],
    on: {
      "click": _vm.highlight
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.executor.agent.name))]), _vm._v(" "), _c('span', {
    staticClass: "badge",
    attrs: {
      "title": "Number of performed instructions",
      "data-toggle": "tooltip",
      "data-placement": "top"
    }
  }, [_vm._v(_vm._s(_vm.executor.elapsedSteps))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.executor.penalty >= 1),
      expression: "executor.penalty >= 1"
    }],
    staticClass: "badge",
    attrs: {
      "title": "Current penalty for instruction cost"
    }
  }, [_vm._v("Penalty: " + _vm._s(_vm.executor.penalty))]), _vm._v(" "), _c('div', {
    staticClass: "instructions"
  }, [(_vm.executor.last) ? _c('div', {
    staticClass: "instruction instruction-last"
  }, [_vm._v("[" + _vm._s(_vm.executor.lastIp) + "] " + _vm._s(_vm.executor.last.id))]) : _vm._e(), _vm._v(" "), (_vm.executor.next) ? _c('div', {
    class: ['instruction', 'instruction-next', {
      'instruction-highlight': _vm.next
    }]
  }, [_vm._v("[" + _vm._s(_vm.executor.ip) + "] " + _vm._s(_vm.executor.next.id))]) : _vm._e()]), _vm._v(" "), (_vm.executor.error) ? _c('div', {
    staticClass: "error-msg",
    attrs: {
      "title": _vm.executor.error.message
    }
  }, [_c('small', [_c('icon', {
    attrs: {
      "name": "warning"
    }
  }), _vm._v(" Runtime error!")], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d7082170!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/workbench/simulator/schedulerPanel/Executor.vue
// module id = 1557
// module chunks = 2